// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DIiu_rPwVqYYTUgjW2U1{flex-direction:column;width:100%;height:100%;display:flex}.dDQgUJvgBdUoCPF0iTc7{margin:0 30px 24px auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentContainer": `DIiu_rPwVqYYTUgjW2U1`,
	"searchContainer": `dDQgUJvgBdUoCPF0iTc7`
};
export default ___CSS_LOADER_EXPORT___;
